import React, { useEffect, useState } from "react"
import { useTranslation, withTranslation } from "react-i18next"

import { Globe } from "lucide-react"
import { usePermissions } from "hooks"
import {
  getUserRoleAndPermissions,
  getCandiateRoleData,
} from "store/actions/roleAction"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import Colors from "constants/Colors"
import { layoutModeTypes } from "constants/layout"

const LanguageDropdown = () => {
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState(null) // Start with null to prevent mismatches
  const { showAll, permissions } = usePermissions("auth")
  const { userType } = useSelector(state => state.Login)
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  const dispatch = useDispatch()

  useEffect(() => {
    if (userType) {
      dispatch(getUserRoleAndPermissions())
    }
    if (userType === "candidate") {
      dispatch(getCandiateRoleData())
    }
  }, [userType])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const savedLanguage = localStorage.getItem("I18N_LANGUAGE") || "en"
      setLanguage(savedLanguage)
      i18n.changeLanguage(savedLanguage)

      // Set the initial direction based on saved language
      if (savedLanguage === "sa") {
        document.body.setAttribute("dir", "rtl")
      } else {
        document.body.setAttribute("dir", "ltr")
      }
    }
  }, [])

  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "sa" : "en"
    setLanguage(newLanguage)
    i18n.changeLanguage(newLanguage)

    // Set the direction of the body to RTL for Arabic, or LTR for English
    if (newLanguage === "sa") {
      document.body.setAttribute("dir", "rtl")
    } else {
      document.body.setAttribute("dir", "ltr")
    }

    if (typeof window !== "undefined") {
      localStorage.setItem("I18N_LANGUAGE", newLanguage)
      window.location.reload()
    }
  }

  return (
    <>
      {(showAll || permissions?.includes("can_change_language")) && (
        <div>
          <button
            style={{
              color:
                layoutMode === layoutModeTypes.LIGHT
                  ? Colors.black
                  : Colors.white,
            }}
            className="tr_btn language_change_btn d-flex align-items-center"
            onClick={toggleLanguage}
          >
            <Globe className="mx-2" width={18} height={18} />
            {language === "en" ? "العربية" : "EN"}
          </button>
        </div>
      )}
      {/* <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item " tag="button">
          <img
            src={get(languages, `${selectedLang}.flag`)}
            alt="SAR"
            height="16"
            className="me-1 mb-1"
          />
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {map(Object.keys(languages), key => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`notify-item ${selectedLang === key ? "active" : "none"
                }`}
            >
              <img
                src={get(languages, `${key}.flag`)}
                alt="SAR"
                className="me-1"
                height="12"
              />
              <span className="align-middle">
                {get(languages, `${key}.label`)}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown> */}
    </>
  )
}

export default withTranslation()(LanguageDropdown)
